import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {SpriteButtonView} from '../ui_canvas_engine/SpriteButtonView'
import {SpriteView} from '../ui_canvas_engine/SpriteView'
import {PIXI} from '@colonist/pixi'
import {ACTIVE_OPACITY, INACTIVE_OPACITY} from '../ui_utils/Utils'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameAnimationBase} from '../ui_canvas_engine/animation/UIGameAnimationBase'
import {CooldownAnimation} from '../ui_canvas_engine/CooldownAnimation'
import {UIGameTradeOfferWaitIconView} from './ui_trade_offers/UIGameTradeOfferWaitIconView'
import {PlayerColor} from '@colonist/game-states'

export class TradeViewSpriteButton extends SpriteButtonView {
    private embargoSlash: SpriteView | undefined

    private cooldownAnimation?: UIGameAnimationBase | undefined
    private waitIcon?: UIGameTradeOfferWaitIconView

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, texture: PIXI.Texture, removePadding?: boolean, iconDefaultSizeRatio: number = 0.6, bgColor?: PlayerColor, notInteractive: boolean = false) {
        super(x, y, w, h, container, removePadding, iconDefaultSizeRatio)
        this.addCenteredIcon(texture)
        const bgTexture = UIGameSpriteHandler.getButtonBg(bgColor)
        this.viewContainer.drawRoundedBg(bgTexture, undefined, 0)
        if(notInteractive) this.interactiveChildren = false
    }

    activateEmbargoState() {
        this.inactivateOpacity()
        this.addEmbargoSlash()
    }

    addEmbargoSlash() {
        const embargoOverlayTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.execute_button_embargo_overlay)
        const embargoOverlayXY = this.width * 0.06
        const embargoOverlayWH = this.width * 1.08
        this.embargoSlash = new SpriteView(-embargoOverlayXY, -embargoOverlayXY, embargoOverlayWH, embargoOverlayWH, this.viewContainer, embargoOverlayTexture, 0)
        this.viewContainer.addChild(this.embargoSlash)
    }

    removeEmbargoSlash() {
        if(this.embargoSlash == undefined) return
        if(this.embargoSlash.parent == undefined) return
        this.embargoSlash.parent.removeChild(this.embargoSlash)
    }

    highlight() {
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button_trade_highlight), true)
    }

    removeHighlight() {
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button_trade), true)
    }

    activateOpacity() {
        this.viewContainer.alpha = ACTIVE_OPACITY
    }

    inactivateOpacity() {
        this.viewContainer.alpha = INACTIVE_OPACITY
    }

    startCooldownAnimation(delayedCooldown: number, animationCallback: () => void, textureToMask: PIXI.Texture) {
        this.cooldownAnimation = new CooldownAnimation(this.viewContainer, delayedCooldown, textureToMask)
        this.cooldownAnimation.setOnStopCallback(animationCallback)
        this.cooldownAnimation.start()
    }

    clearCooldownAnimation() {
        if(this.cooldownAnimation == undefined) return
        const ignoreCallback = true
        this.cooldownAnimation.stop(ignoreCallback)
        this.cooldownAnimation = undefined
    }

    showCreatingCounterOfferWaitIcon(playerName: string) {
        this.waitIcon ??= new UIGameTradeOfferWaitIconView(this, playerName, 0.5)
        this.waitIcon.show()
    }

    hideCreatingCounterOfferWaitIcon() {
        this.waitIcon?.hide()
    }

    restartCreatingCounterOfferWaitIcon() {
        this.waitIcon?.restart()
    }

    destroy(): void {
        this.clearCooldownAnimation()
        this.waitIcon?.destroy()

        super.destroy()
    }
}
